export const csvPreview = {
  state: () => ({
    models: [],
  }),
  mutations: {
    setCsvModels(state, payload) {
      state.models = Array.isArray(payload) ? payload : [];
    },
    clearCsvModels(state) {
      state.models = [];
    },
  },
  getters: {
    csvModels: (state) => state.models || [],
    csvModelByKey: (state) => (key) =>
      (state.models || []).find((m) => m.key === key),
  },
};

